import logo from '../resources/media/netapp-logo-with-title.svg';
import React  from 'react';
import * as _ from 'lodash';
import classnames from 'classnames';
import axios from 'axios';
import {CIG_SSO} from '../common/constants';
import {getCookie, sendRedirectWithForm, getCloudHomeUrl} from '../common/utils';


export function CigHeader({showLogout, cmMode, cloudHomeUrl, title, documentUrl, tenantId, site}) {
    const logout = () => {
        sendRedirectWithForm('/ui/logout', _.isNil(tenantId) ? 'gateway-internal-tenant-id' : tenantId, site);
    }

    const handleLogout = () => {
        window.history.replaceState({cighs: 'abc'}, null, window.location.href);
        const token = getCookie('', CIG_SSO.cookieJWT);
        if (_.isEmpty(token)) {
            window.CIG_LOG.info('Gateway: CigHeader - Error Page - Empty token.');
            logout();
        } 
        else {
            const headers = {'Authorization': `Bearer ${token}`};
            axios
                .delete('/rest/v1/authorize/authcontext', {headers})
                .then(() => {
                    window.CIG_LOG.debug('Gateway: CigHeader - Successful reset tenant authorize context.');
                    logout();
                })
                .catch(function (err) {
                    window.CIG_LOG.info('Gateway: CigHeader - Fail to reset tenant authorize context.' + err);
                    logout();
                });
        }
    }

    const netappLogo = () => {
        return (
            <>
                <img src={logo} alt="NetApp" width="132" height="132" className="tw-pl-6px"/>
                <span className="tw-text-white tw-text-lg tw-px-8px tw-mt-12px tw-mb-10px">Data Infrastructure Insights</span>
                {
                    cmMode && <span id="blue-xp-text" className="tw-text-white tw-whitespace-nowrap tw-font-medium tw-text-22px tw-pl-lg tw-mt-2px">NetApp Console</span>
                }
            </>
        )
    }

    const showlogo = () => {
        return (
            <>
                <div id="logo-url" className="tw-ml-32px tw-text-white tw-no-underline" data-testid="logo-url">
                    <a id="logo-url-link" className={classnames('tw-no-underline tw-flex', {'tw-pointer-events-none': _.isEmpty(cloudHomeUrl)})}
                        href={getCloudHomeUrl(cloudHomeUrl)} rel="noreferrer noopener" target="_blank" data-testid="logo-url-enterprise">
                        { netappLogo() }
                    </a>
                </div>
            </>
        );
    }

    return (
        <header>
            <div id="header-banner" className={classnames('tw-flex tw-flex-row tw-items-center tw-text-white tw-justify-between tw-pt-12px tw-pb-12px tw-pr-xl', {'tw-bg-banner': true, 'tw-bg-banner-dark-blue': false})}>
                {
                    showlogo()
                }
                {
                    !_.isEmpty(title) && <label className="tw-text-white tw-mb-2px tw-mr-12px">{title}</label>
                }
                {
                    (_.isUndefined(showLogout) || showLogout === true) && (
                        <button id="logout" className='tw-text-white tw-mb-2px focus:tw-link-gray-500 hover:tw-link-gray-500' onClick={handleLogout}>Log out</button>
                    )
                }
                {
                    !_.isEmpty(documentUrl) &&
                        <a id="ci-document" className='tw-text-white tw-mb-2px focus:tw-link-gray-500 hover:tw-link-gray-500' href={documentUrl} rel="noreferrer noopener"  target="_blank">About regional support...</a>
                }
            </div>
        </header>
    );
}

CigHeader.displayName = 'CigHeader';
export default CigHeader;
